<div id="settings-recipient-options-management" class="container-fluid pb-3">

    <div class="row">

        <!-- LEFT COLUMN WITH SEARCH AND RECIPIENT-OPTIONS LIST -->

        <div class="col-sm-12 col-md-4">
            <mat-card>
                <mat-card-content>

                    <div class="row no-gutters mb-3">
                        <button id="{{idPrefix}}btn.create_new"
                                mat-flat-button color="accent"
                                class="full-width"
                                (click)="create()"
                                [disabled]="disabled">
                            {{ 'recipient_options_management.btn.create' | translate | uppercase }}
                        </button>
                    </div>

                    <div class="row no-gutters">
                        <mat-form-field class="full-width">
                            <mat-label>{{ 'common.label.search' | translate }}</mat-label>
                            <input id="{{idPrefix}}filter.input_text.searchText"
                                   type="text" matInput
                                   [(ngModel)]="filter.searchText">
                            <button id="{{idPrefix}}filter.btn.clear_searchText"
                                    mat-button
                                    matSuffix mat-icon-button
                                    aria-label="'common.label.search' | translate"
                                    *ngIf="filter.searchText"
                                    (click)="filter.searchText = ''">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>


                    <!-- REGULAR RESULT LIST -->

                    <action-list *ngIf="filter.filteredArray"
                                 [items]="filter.filteredArray"
                                 [selected]="selected"
                                 [options]="actionListOptions"
                                 [idPrefix]="idPrefix"
                                 (select)="select($event)"
                                 (delete)="delete($event)">
                    </action-list>

                </mat-card-content>
            </mat-card>
        </div>


        <!-- RIGHT COLUMN WITH SELECTED USER -->


        <div class="col-sm-12 col-md-8">

            <mat-card>
                <mat-card-content>

                    <recipient-options *ngIf="selected"
                                       [(bananaBox)]="selected"
                                       (bananaBoxChange)="updateInList()"
                                       [channels]="claimNetChannels"
                                       (canceled)="cancel()"
                                       [idPrefix]="idPrefix">
                    </recipient-options>

                </mat-card-content>
            </mat-card>

        </div>

    </div>

</div>
